import config from './config';

export const cognitoAuthConfig = {
    authority: `https://cognito-idp.${config.cognito.region}.amazonaws.com/${config.cognito.userPoolId}`,
    client_id: config.cognito.userPoolClientId,
    redirect_uri: config.cognito.redirectSignIn[0],
    response_type: config.cognito.responseType,
    scope: config.cognito.scopes.join(" "),
};

export const cognitoDomain = `https://${config.cognito.domain}`;
